import { useTranslations } from 'next-intl'
import { ComponentProps } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { PhoneField } from '@/features/update-user-information'
import { PhoneVerificationButton } from '@/features/verify-identity'
import { isNilOrEmptyString } from '@/shared/lib'

type Props = Pick<ComponentProps<typeof PhoneVerificationButton>, 'onSuccess'>

export const PhoneVerificationField = ({ onSuccess }: Props) => {
  const t = useTranslations('user_information')

  const { control } = useFormContext()

  const phoneNumber = useWatch({
    control,
    name: 'phoneNumber',
  })

  const isVerified = !isNilOrEmptyString(phoneNumber)

  return (
    <div className="space-y-2">
      <PhoneField label={t('phone_number_label')} />
      <PhoneVerificationButton onSuccess={onSuccess} disabled={isVerified}>
        {isVerified
          ? t('button.verify_phone_completed')
          : t('button.verify_phone')}
      </PhoneVerificationButton>
    </div>
  )
}
